import { muiComponentsMenuItem } from './muiComponentsMenuItem'
import { muiComponentsListItems } from './muiComponentsListItems'

export const muiComponentsMenusItems = {
  ...muiComponentsMenuItem,
  ...muiComponentsListItems,
}
